'use strict';

exports.__esModule = true;
var ON_FILTER_OPEN_CHANGED = exports.ON_FILTER_OPEN_CHANGED = 'filters@ON_FILTER_OPEN_CHANGED';
var ON_FILTER_SORT_FIELD_CHANGED = exports.ON_FILTER_SORT_FIELD_CHANGED = 'filters@ON_FILTER_SORT_FIELD_CHANGED';
var ON_FILTER_SORT_ORIENTATION_CHANGED = exports.ON_FILTER_SORT_ORIENTATION_CHANGED = 'filters@ON_FILTER_SORT_ORIENTATION_CHANGED';
var ON_ADD_FILTER_QUERY = exports.ON_ADD_FILTER_QUERY = 'filters@ON_ADD_FILTER_QUERY';
var ON_EDIT_FILTER_QUERY = exports.ON_EDIT_FILTER_QUERY = 'filters@ON_EDIT_FILTER_QUERY';
var ON_REMOVE_FILTER_QUERY = exports.ON_REMOVE_FILTER_QUERY = 'filters@ON_REMOVE_FILTER_QUERY';
var ON_SET_SEARCH = exports.ON_SET_SEARCH = 'filters@ON_SET_SEARCH';


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-filter/lib/store/types.js
// module id = 699
// module chunks = 49